import React from 'react';
import { setLanguage, getLanguage, type Language } from '@deadpan/shared';

export const LanguageSwitcher: React.FC = () => {
  const [currentLang, setCurrentLang] = React.useState<Language>(getLanguage());

  React.useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLang(getLanguage());
    };
    window.addEventListener('languagechange', handleLanguageChange);
    return () => window.removeEventListener('languagechange', handleLanguageChange);
  }, []);

  const handleLanguageChange = (lang: Language) => {
    setLanguage(lang);
    setCurrentLang(lang);
    window.dispatchEvent(new Event('languagechange'));
  };

  return (
    <div className="flex items-center gap-1 sm:gap-2">
      <span className="text-xs sm:text-sm text-gray-600 font-medium">🌐</span>
      <div className="flex bg-white/90 backdrop-blur-sm rounded-lg border-2 border-gray-200 overflow-hidden">
        <button
          onClick={() => handleLanguageChange('en')}
          className={`px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-semibold transition-all ${
            currentLang === 'en'
              ? 'bg-gradient-to-r from-indigo-500 to-purple-500 text-white'
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          EN
        </button>
        <button
          onClick={() => handleLanguageChange('zh')}
          className={`px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-semibold transition-all ${
            currentLang === 'zh'
              ? 'bg-gradient-to-r from-indigo-500 to-purple-500 text-white'
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          中文
        </button>
      </div>
    </div>
  );
};

